import { inject as service } from '@ember/service';
import { gt, equal, alias } from '@ember/object/computed';
import Controller from '@ember/controller';
import { EMBER_ROUTE_NAMES } from '../../../constants/routes';

/** @module */
const CreatorSignupDoneController = Controller.extend({
  router: service(),

  /** @type {Ember.ComputedProperty} */
  wasInvited: gt('model.user.inviters.length', 0),

  /** @type {Ember.ComputedProperty} */
  singleInvite: equal('model.user.inviters.length', 1),

  /** @type {Ember.ComputedProperty} */
  inviterName: alias('model.user.inviters.firstObject.name'),

  /** @type {Ember.ComputedProperty} */
  inviterCompany: alias('model.user.inviters.firstObject.company.name'),

  /** @inheritDoc */
  actions: {
    /**
     *
     */
    finish() {
      this.get('router').transitionTo(EMBER_ROUTE_NAMES.PROFILE, this.get('model.user.slug'));
    },
  },
});

export default CreatorSignupDoneController;
